/**
 * Entity Definition System - Core Types and Utilities
 *
 * This module provides the foundation for a single-source-of-truth entity definition system.
 * Each entity is defined once with its schema and relations, and TypeScript automatically
 * extracts all needed types (populate fields, conditional types, etc.).
 *
 * Usage:
 *   const UserEntityDef = defineEntity({
 *     name: "user",
 *     schema: UserSchema,
 *     relations: {
 *       role: { type: "one", entity: () => UserRoleEntityDef },
 *       exchange_accounts: { type: "many", entity: () => ExchangeAccountEntityDef },
 *     },
 *   });
 *
 *   type UserPopulateField = PopulateField<typeof UserEntityDef>;
 *   type UserWithRole = EntityWithPopulate<typeof UserEntityDef, ["role"]>;
 */
/**
 * Create an entity definition with proper type inference
 */
export function defineEntity(config) {
    return config;
}
